module.exports = __webpack_public_path__ + "img/icons BFr_21.0ca3327b.svg";